import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';

import PageHeading from '@RHEnvironmental/pattern-library/dist/js/components/PageHeading';
import PageSection from '@RHEnvironmental/pattern-library/dist/js/components/PageSection';
import LoadingIndicator from '@RHEnvironmental/pattern-library/dist/js/components/LoadingIndicator';
import Button from '@RHEnvironmental/pattern-library/dist/js/components/Button';

import MainLayout from '../../modules/MainLayout';
import BodyText from '../../modules/BodyText';

import { getSessionUser } from '../../../selectors/session';
import * as sessionActions from '../../../actions/session';
import navigator from '../../../services/ui/navigator';
import { setAlert } from '../../../actions/alerts';

const LicenceAgreement = ({
    updateLicenceRecord,
    selectedLicence,
    sessionUser,
    isUpdatingLicence,
    setSelectedLicence,
}) => {
    const dispatch = useDispatch();

    useEffect(() => {
        const licences = [
            {
                type: 'eula',
                name: 'EULA',
                link: window.config.raw_eula_licence_link,
                signed: sessionUser.licence_record?.eula_signed ?? false,
            },
            {
                type: 'tos',
                name: 'Terms of Service',
                link: window.config.raw_tos_licence_link,
                signed: sessionUser.licence_record?.terms_agreed ?? false,
            },
        ];

        const licenceToSign = licences.find((licence) => !licence.signed);

        if (licenceToSign) {
            setSelectedLicence(licenceToSign);
        } else {
            dispatch(
                setAlert('All licence agreements are up to date.', 'success')
            );

            navigator.push('inspections');
        }
    }, [sessionUser]);

    return (
        <MainLayout>
            <PageSection className="page-section--fixed-width-container page-section--green">
                <PageHeading level={5} className="mb-4">
                    Licence Agreement
                </PageHeading>
                <div className="mb-8">
                    {selectedLicence && (
                        <PageHeading level={4} className="mb-4">
                            {selectedLicence.name}
                        </PageHeading>
                    )}
                </div>
            </PageSection>
            <PageSection className="page-section--fixed-width-container">
                {!selectedLicence ? (
                    <LoadingIndicator show />
                ) : (
                    <>
                        <BodyText>
                            To proceed, you must read the following agreement
                            and click the button below to accept.
                        </BodyText>
                        <iframe
                            title={selectedLicence.name}
                            frameBorder="0"
                            src={selectedLicence.link}
                            className="licence-container"
                        />
                        <Button
                            disabled={isUpdatingLicence}
                            onClick={() =>
                                updateLicenceRecord(selectedLicence.type)
                            }
                        >
                            Accept
                        </Button>
                    </>
                )}
            </PageSection>
        </MainLayout>
    );
};

const mapStateToProps = (state) => ({
    sessionUser: getSessionUser(state),
    ...state.models.session,
});

const mapDispatchToProps = (dispatch) => ({
    updateLicenceRecord(licenceType) {
        dispatch(sessionActions.updateLicenceRecord(licenceType));
    },
    setSelectedLicence(selectedLicence) {
        dispatch(sessionActions.selectedLicenceRefreshed(selectedLicence));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(LicenceAgreement);
